import { Dialog } from "primereact/dialog";
import { Button } from "react-bootstrap";

const ConfirmDialogBox = ({
  visible,
  onHide,
  onConfirm,
  title = "",
  message = "",
  confirmLabel = "Yes",
  cancelLabel = "No",
  icon ,
    loading = false 
}) => {
  const isDeleteAction = confirmLabel?.toLowerCase().includes("delete");

  const footer = (
    <div
      className={`d-flex pb-2 ${
        cancelLabel ? "justify-content-between" : "justify-content-end"
      }`}
    >
      {cancelLabel && (
        <Button
          variant="outline-secondary"
          className="px-4 py-2"
          onClick={onHide}
        >
          {cancelLabel}
        </Button>
      )}
      {confirmLabel && (
        <Button
          variant={isDeleteAction ? "danger" : "primary"}
          className="px-4 py-2"
          onClick={onConfirm}
          disabled={loading} 
        >
          {loading ? "Please wait..." : confirmLabel}
        </Button>
      )}
    </div>
  );

  return (
    <Dialog visible={visible} onHide={onHide} footer={footer} modal closable={false}>
      <div className="text-center">
        {icon && (
          <div className="mb-3">
            <img src={icon} width={60} alt="icon" />
          </div>
        )}
        <h5 className="mb-2 fw-normal">{title}</h5>

        {message && <p className="mb-0">{message}</p>}
      </div>
    </Dialog>
  );
};

export default ConfirmDialogBox;